import React, { useEffect, useState } from "react"
import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import XLSX from 'xlsx-js-style'
import { styleExcelSheet } from 'helpers/excel'

import { Dropdown , Modal } from 'react-bootstrap'
import { toast } from 'react-toastify'
import Select from 'react-select'
import FilterSearch from 'pages/parts/FilterSearch'
import Pagination from 'pages/parts/Pagination'
import DatePicker from "react-datepicker"

import { GET, PGET } from 'helpers/api'
import { formatMoney, formatDate, checkRole, findFromArrayById, formatDateBackend } from 'helpers/helpers'
import { Scanner } from '@yudiel/react-qr-scanner'

function Index() {

	const { t } = useTranslation()

	const reduxSettings = useSelector(state => state.settings)
	const reduxAccount = useSelector(state => state.account)

	const URL = `/services/web/api/documents-out-pageList/`
	const TOTAL_URL = `/services/web/api/documents-out-total/`

	const canCreate = checkRole('POS_DOCUMENT_OUT_ADD')

	const [pageCount, setPageCount] = useState(0)
	const [totalAmount, setTotalAmount] = useState(null)

	const [dropdownIsOpen, setDropdownIsOpen] = useState(false)
	const [filterDataExist, setFilterDataExist] = useState(false)
	const [filterData, setFilterData] = useState({
		posId: reduxAccount.posId,
		startDate: null,
		endDate: null,
		search: '',
	})
	const [poses, setPoses] = useState([])
	const [data, setData] = useState([])

	const [modalScanner, setModalScanner] = useState(false)
	const [scannerZoom, setScannerZoom] = useState(1)
	const [isMobile, setIsMobile] = useState(false)

	async function exportToExcel(item) {
		const response = await GET('/services/web/api/documents-out/' + item.id)

		var excelHeaders = []
		excelHeaders.push([t('DOCUMENT_FROM'), formatDate(response?.createdDate)])
		excelHeaders.push([t('POS'), response['posName'], t('RETURN') + '№', response?.outNumber])
		excelHeaders.push([t('SUPPLIER'), response['organizationName'], t('NOTE'), response?.note])
		excelHeaders.push([t('CURRENCY'), formatMoney(response['currencyName'])])
		excelHeaders.push([''])
		excelHeaders.push([
			t('NAME_OF_PRODUCT'), t('BARCODE'), t('SERIAL'), t('EXPIRATION_DATE'), t('RETURN_QUANTITY'), t('ADMISSION_PRICE'), t('DIVERGENCE'), t('TOTAL_AMOUNT')
		])

		for (let i = 0; i < response.productList.length; i++) {
			var excelItems = []
			excelItems.push(response.productList[i]['productName'])
			excelItems.push(response.productList[i]['barcode'])
			excelItems.push(response.productList[i]['serial'])
			excelItems.push(response.productList[i]['expDate'])
			excelItems.push(response.productList[i]['quantity'] + response.productList[i].uomName)
			excelItems.push(formatMoney(response.productList[i]['totalAmount']))
			excelHeaders.push(excelItems)
		}
		excelHeaders.push([''])
		excelHeaders.push([t('TOTAL'), formatMoney(response['totalAmount'])])

		const ws = XLSX.utils.aoa_to_sheet(excelHeaders);
		styleExcelSheet(ws)
		const wb = XLSX.utils.book_new();
		XLSX.utils.book_append_sheet(wb, ws, "SheetJS");
		XLSX.writeFile(wb, t('RETURN') + ".xlsx");
	}

	async function getData() {
		checkFilter()
		const response = await PGET(URL + filterData.posId, filterData)
		if (response && response.data) {
			setPageCount(Math.ceil((response?.headers['x-total-count']) / reduxSettings.size))
			setData(response.data)
			setDropdownIsOpen(false)
		}

		const totalResponse = await GET(TOTAL_URL + filterData.posId, filterData)
		if (totalResponse) {
			console.log(totalResponse)
			setTotalAmount(totalResponse.totalAmount ?? 0)
		}
	}

	function resetFilter() {
		setFilterData({
			...filterData,
			search: '',
		})
		getData()
	}

	function checkFilter() {
		if (
			filterData.posId === null &&
			filterData.search === ''
		) {
			setFilterDataExist(false)
		} else {
			setFilterDataExist(true)
		}
	}

	async function paginate(data) {
		const response = await PGET(URL + filterData.posId, { ...filterData, page: data.selected, size: reduxSettings.size })
		setData(response.data);
	}

	async function getPoses() {
		const response = await GET("/services/web/api/pos-helper", {}, { loader: true })
		if (response) {
			setPoses(response)
		}

	}

		function handleScannerResult(scannedValue) {
		setFilterData({
			...filterData,
			search: scannedValue,
			page: 0,
		})
	
		setModalScanner(false)
		setScannerZoom(1)
		toast.success(t('SCANNED_SUCCESSFULLY') || 'Muvaffaqiyatli skanerlandi!')
	}

	useEffect(() => {
		getPoses()
	}, []) // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		getData(true)
		const checkMobile = () => {
		setIsMobile(
			window.innerWidth <= 768 ||
			/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
		)
	}

	checkMobile()
	window.addEventListener('resize', checkMobile)

	return () => window.removeEventListener('resize', checkMobile)
	}, [filterData.search]) // eslint-disable-line react-hooks/exhaustive-deps

	return (
		<>
			<div className="page-header d-flex justify-content-between mb-2">
				<h4 className="vertical-center">
					{t('RETURN_TO_SIPPLIER')}
				</h4>
				<div className="d-flex">
					{canCreate &&
						<Link className="btn-rounded btn btn-primary" to="/documents-out/create">
							<i className="uil uil-plus me-2"></i>
							{t('CREATE')}
						</Link>
					}
				</div>
			</div>

			<div className="card">
				<div className="card-body">
					<div className="d-flex mb-3">
						<div>
							<FilterSearch
								filterData={filterData}
								setFilterData={setFilterData}>
							</FilterSearch>
						</div>
						{isMobile && (
								<div
									style={{
										width: '45px',
										marginRight: '10px',
										borderRadius: '8px',
										flexShrink: 0,
										backgroundColor: '#25B17B',
										display: 'flex',
										alignItems: 'center',
										justifyContent: 'center',
										cursor: 'pointer'
									}}
									onClick={() => setModalScanner(true)}
								>
									<i className="uil uil-capture" style={{ color: '#fff', fontSize: '22px' }}></i>
								</div>
							)}
						<div>
							<Dropdown onToggle={() => setDropdownIsOpen(!dropdownIsOpen)} show={dropdownIsOpen}>
								<Dropdown.Toggle variant="outline-primary" className="btn-wide h-100 me-2">
									{t('FILTER')}
								</Dropdown.Toggle>

								<Dropdown.Menu className="dropdown-filter">
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('POS')}</label>
											<Select
												options={poses}
												value={poses.find(option => option.id === filterData.posId) || ''}
												onChange={(option) => setFilterData({ ...filterData, 'posId': option.id })}
												placeholder=""
												noOptionsMessage={() => t('LIST_IS_EMPTY')}
												getOptionLabel={(option) => option.name}
												getOptionValue={(option) => option.id}
											/>
										</div>
									</div>
									<div className="row">
										<div className="form-group col-md-6">
											<label>{t('PERIOD')}</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.startDate ? new Date(filterData.startDate) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'startDate': formatDateBackend(date) })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
										<div className="form-group col-md-6">
											<label className="invisible">.</label>
											<div className="calendar-input">
												<DatePicker
													className="form-control"
													dateFormat="dd.MM.yyyy"
													selected={filterData.endDate ? new Date(filterData.endDate) : ''}
													onChange={(date) => setFilterData({ ...filterData, 'endDate': formatDateBackend(date) })} />
												<i className="uil uil-calendar-alt"></i>
											</div>
										</div>
									</div>
									<div className="row mt-3">
										<div className="col-md-12">
											<div className="d-flex justify-content-end">
												<button type="button" className="btn btn-secondary me-2" onClick={() => setDropdownIsOpen(false)}>{t('CANCEL')}</button>
												<button type="button" className="btn btn-primary" onClick={() => getData(true)}>{t('APPLY')}</button>
											</div>
										</div>
									</div>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>
					<div className="mb-3">
						<div className="d-flex align-items-center justify-content-end">
							<h4 className="me-2 mb-0">
								<b>{t('TOTAL_AMOUNT')}</b>:
							</h4>
							<h4 className="mb-0">
								{totalAmount !== null && formatMoney(totalAmount)}
							</h4>
						</div>
					</div>

					{filterDataExist &&
						<div className="filter-block mb-3">
							<div className="filter">
								<strong>{t('FILTER')}</strong>
								<br />
								{filterData.posId &&
									<span className="me-2">
										<b>{t('POS')}: </b> {findFromArrayById(poses, filterData.posId)}
									</span>
								}
								{filterData.search &&
									<span className="me-2">
										<b>{t('SEARCH')}: </b>
										<span>{filterData.search}</span>
									</span>
								}
							</div>
							<div className="vertical-center">
								<button className="btn btn-outline-dark text-uppercase" onClick={resetFilter}>{t('RESET')}</button>
							</div>
						</div>
					}

					<div className="table-responsive">
						<table className="table table-striped mb-0">
							<thead>
								<tr>
									<th>{t('POS')}</th>
									<th>{t('SUPPLIER')}</th>
									<th className="text-center">№ {t('RETURN')}</th>
									<th className="text-center">{t('AMOUNT')}</th>
									<th className="text-center">{t('DATE_OF_RETURN')}</th>
									<th className="text-center">{t('ACTION')}</th>
								</tr>
							</thead>
							<tbody>
								{data.length > 0 ? data.map((item, index) => (
									<tr key={index}>
										<td>{item.rowNum}. {item.posName}</td>
										<td>{item.organizationName}</td>
										<td className="text-center">{item.outNumber}</td>
										<td className="text-center">{formatMoney(item.totalAmount)}</td>
										<td className="text-center">{formatDate(item.createdDate)}</td>
										<td className="d-flex justify-content-center">
											<Link to={`/documents-out/preview/${item.id}`}>
												<div className="table-action-button table-action-primary-button me-2">
													<i className="uil-eye"></i>
												</div>
											</Link>
											<div className="table-action-button table-action-success-button" onClick={() => exportToExcel(item)}>
												<i className="uil-file-alt"></i>
											</div>
										</td>
									</tr>
								)) : <tr>
									<td colSpan="10" className="text-center">{t('NO_DATA')}</td>
								</tr>
								}
							</tbody>
						</table>
					</div>

					<Pagination pageCount={pageCount} paginate={paginate}></Pagination>
				</div>
			</div>
			<Modal
							show={modalScanner}
							animation={false}
							centered
							onHide={() => {
								setModalScanner(false)
								setScannerZoom(1)
							}}
						>
							<Modal.Header closeButton>
								<Modal.Title>{t('SCAN_BARCODE') || 'Shtrix-kodni skanerlash'}</Modal.Title>
							</Modal.Header>
			
							<Modal.Body>
								<div style={{ width: '100%', height: '300px', overflow: 'hidden', position: 'relative' }}>
									<div
										style={{
											width: '100%',
											height: '100%',
											transform: `scale(${scannerZoom})`,
											transformOrigin: 'center center'
										}}
									>
										<Scanner
											onScan={(result) => {
												if (result && result.length > 0) {
													const scannedValue = result[0].rawValue
													handleScannerResult(scannedValue)
												}
											}}
											onError={(error) => console.log(error?.message)}
											formats={[
												'code_128',
												'code_39',
												'ean_13',
												'ean_8',
												'upc_a',
												'upc_e',
												'itf',
												'data_matrix',
												'aztec'
											]}
											scanDelay={0}
											constraints={{ facingMode: 'environment' }}
											styles={{
												container: { width: '100%', height: '100%' },
												video: { width: '100%', height: '100%', objectFit: 'cover' }
											}}
										/>
									</div>
								</div>
			
								<div className="d-flex justify-content-center align-items-center gap-3 mt-3">
									<button
										type="button"
										className="btn btn-outline-secondary"
										style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
										onClick={() => setScannerZoom(prev => Math.max(1, prev - 0.5))}
										disabled={scannerZoom <= 1}
									>
										<i className="uil uil-minus"></i>
									</button>
			
									<span style={{ minWidth: '60px', textAlign: 'center', fontSize: '18px', fontWeight: 'bold' }}>
										{scannerZoom}x
									</span>
			
									<button
										type="button"
										className="btn btn-outline-secondary"
										style={{ width: '50px', height: '50px', fontSize: '24px', borderRadius: '50%' }}
										onClick={() => setScannerZoom(prev => Math.min(4, prev + 0.5))}
										disabled={scannerZoom >= 4}
									>
										<i className="uil uil-plus"></i>
									</button>
								</div>
							</Modal.Body>
			
							<Modal.Footer>
								<button
									className="btn btn-warning w-100"
									onClick={() => {
										setModalScanner(false)
										setScannerZoom(1)
									}}
								>
									{t('CANCEL')}
								</button>
							</Modal.Footer>
						</Modal>
		</>
	)
}

export default Index
